<router-outlet></router-outlet>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
    <p style="font-size: 14px; color: white">{{ 'appSpinnerText' | translate }}</p>
</ngx-spinner>